import React from "react";

const Footer = () => {
  return (
    <div className="mx-auto px-4 md:px-10 lg:px-20 xl:px-48 mt-4 ">
      {" "}
      <div className="flex gap-5 md:gap-40 justify-center w-full">
        <div>
          <h2 className="font-semibold text-xl">About Us</h2>
          <ul>
            <li>Our Company</li>
            <li>Culture and Values</li>
            <li>Contact Us</li>
            <li>Delivery</li>
          </ul>
        </div>

        <div className="">
          <h2 className="font-semibold text-xl">About Us</h2>
          <ul>
            <li>Our Company</li>
            <li>Culture and Values</li>
            <li>Contact Us</li>
            <li>Delivery</li>
          </ul>
        </div>

        <div className="">
          <h2 className="font-semibold text-xl">About Us</h2>

          <ul>
            <li>Our Company</li>
            <li>Culture and Values</li>
            <li>Contact Us</li>
            <li>Delivery</li>
          </ul>
        </div>
      </div>

      <div className="flex justify-center gap-15 md:gap-20 my-6">
        <p>Privacy Notice</p>
        <p>Terms of use</p>
        <p>CA Supply Chain</p>
        <p>Cookie Preference</p>
      </div>

      <hr />
      <br></br>
      
      <p className="text-center pb-6">
        © 2024 NapBook Company. All rights reserved.
      </p>
    </div>
  );
};

export default Footer;
